import { render, staticRenderFns } from "./dealsComponent.vue?vue&type=template&id=729f8c66&scoped=true&"
import script from "./dealsComponent.vue?vue&type=script&lang=js&"
export * from "./dealsComponent.vue?vue&type=script&lang=js&"
import style0 from "./dealsComponent.vue?vue&type=style&index=0&id=729f8c66&scoped=true&lang=css&"
import style1 from "./dealsComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729f8c66",
  null
  
)

export default component.exports